import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Form,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { AlertCircle } from "react-feather";
import toast from "react-hot-toast";

import printService from "../../../../services/print.service";

const SkuForm = ({ submitting, setSubmitting, sku, setSku }) => {
  const [errorMessage, setErrorMessage] = useState();

  const inputElement = useRef(null);

  const handleSubmit = async () => {
    setErrorMessage(null);

    if (!sku) {
      toast.error("Please enter a SKU.");
      return;
    }

    // Check if the value is "W". ¯\_(ツ)_/¯
    if (sku.toString().toUpperCase() === "W") {
      toast.error("Please re-scan the SKU or enter it manually.");
      setSku("");
      return;
    }

    setSubmitting(true);

    const result = await printService.printEbayAuctionLabel({
      sku,
    });

    if (!result.success) {
      setErrorMessage(result.message);
    }

    setSku("");

    if (inputElement.current) {
      inputElement.current.focus();
      inputElement.current.select();
    }

    setSubmitting(false);
  };

  return (
    <>
      <Card>
        <Card.Header className="d-flex justify-content-start">
          <FontAwesomeIcon icon={faBarcode} size="3x" className="me-3" />
          <div>
            <Card.Title>SKU</Card.Title>
            <Card.Subtitle>
              Scan or enter a SKU to print it's Auction Label.
            </Card.Subtitle>
          </div>
        </Card.Header>
        <Card.Body>
          {errorMessage && (
            <Alert variant="danger" className="flex-fill alert-blink">
              <div className="alert-icon">
                <AlertCircle
                  className="position-relative top-50 start-50 translate-middle"
                  size={20}
                />
              </div>
              <div className="alert-message font-weight-bold">
                {errorMessage}
              </div>
            </Alert>
          )}
          <Form.Label className="mb-0">SKU</Form.Label>
          <InputGroup>
            <Form.Control
              required
              autoFocus
              size="lg"
              placeholder="Scan or Enter SKU..."
              ref={inputElement}
              value={sku}
              onChange={(e) => {
                setSku(e.target.value);
              }}
              onFocus={(e) => {
                e.target.select();
              }}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
            />
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? (
                <span>
                  <Spinner
                    className="me-2"
                    animation="border"
                    size="sm"
                    role="status"
                  />
                  Submitting...
                </span>
              ) : (
                "Submit"
              )}
            </Button>
          </InputGroup>
        </Card.Body>
      </Card>
    </>
  );
};

export default SkuForm;
